module.exports = __webpack_public_path__ + "ed01b66f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/singapore.png
// module id = 1708
// module chunks = 0